<ngb-datepicker *ngIf="!hasBeenReset"
                [(ngModel)]="model"
                [dayTemplate]="dayTemplate"
                [displayMonths]="displayMonths"
                [outsideDays]="'visible'"
                [showWeekNumbers]="showWeekNumbers"
                [minDate]="minDate ? momentToNgbDate(minDate): null"
                [maxDate]="maxDate ? momentToNgbDate(maxDate): null"
                (dateSelect)="onDateSelect($event)">
</ngb-datepicker>
<ng-template #dayTemplate let-date let-currentMonth="currentMonth" let-focused="focused">
  <div class="mui-datepicker__day-wrapper"
       [class.from-date]="isFromDate(date) && isRangeSelected()"
       [class.to-date]="isToDate(date) && isRangeSelected()">
    <div tabindex="0" class="mui-datepicker__day"
         [class.selected]="isSelectedDate(date)"
         [class.not-in-month]="date.month !== currentMonth"
         [class.in-range]="isInDateRange(date)"
         [class.focused]="focused">{{ date.day }}
    </div>
  </div>
</ng-template>
